<div
  class="bg-surface border-b-weak flex shrink-0 flex-wrap items-center gap-4 border-b px-3.5 py-1">
  <span class="text-text-secondary inline-flex items-center gap-1.5 text-[11.5px]">
    <span
      class="border-t-text-tertiary bg-interactive h-2.5 w-3.5 shrink-0 rounded-xs border-t-[1.5px] border-dashed"></span>
    {{ 'common.calendar.legend.after_cutoff' | translate }}
  </span>

  <span class="text-text-secondary inline-flex items-center gap-1 text-[11.5px]">
    <i [class]="ICONS.repeat" class="text-text-tertiary text-[12px]"></i>
    {{ 'common.calendar.legend.recurring' | translate }}
  </span>

  <div class="flex-1"></div>

  <span class="text-text-tertiary shrink-0 font-mono text-[11px]">
    {{ 'common.calendar.legend.event_count' | translate: { count: eventCount() } }}
  </span>
</div>
